import { combineReducers } from "@reduxjs/toolkit";
import { filtersSlice, filtersSliceSelectors } from "./filters-slice";
import { notesState } from "./notes-slice";
import { notesSelectors } from "./notes-selectors";

export const notesContentReducer = combineReducers({
  filters: filtersSlice.reducer,
  notes: notesState.reducer,
});

export const notesContentActions = {
  ...filtersSlice.actions,
  ...notesState.actions,
};

export const notesContentSelectors = {
  ...filtersSliceSelectors,
  ...notesSelectors,
};
